import React from 'react';
import styled from 'astroturf/react';

import CustomVideoPlayer from 'js/videos/shared/player/CustomVideoPlayer.wjs';
import Playlist, { PlaylistProps } from './Playlist';
import Instructor from './Instructor';
import {
  PremiumVideo,
  Instructor as InstructorProps,
} from '../../shared/course_helper';
import VideoUnavailable from '../../shared/VideoUnavailable';

const PlayerContainer = styled.div``;

const PlayerArea = styled.div`
  padding-top: 56.25%; // hacky way to enfore 16:9 aspect ratio
  height: 0;
  position: relative;

  ${PlayerContainer} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;

    // Since the muse player is the only direct descendant, set the
    // dimensions to the container size
    & > * {
      width: 100%;
      height: 100%;
    }
  }
`;

const InfoArea = styled.div`
  padding: 10px 16px 22px 16px;
`;

const HorizontalRule = styled.hr`
  margin-top: 18px;
  margin-bottom: 18px;
  border-top: 1px solid #dddfe2;
  width: 100%;
`;

export interface CourseCardProps {
  courseId: string;
  trailer?: PremiumVideo;
  playlist: PlaylistProps;
  instructor: InstructorProps;
}

const CourseCard: React.FunctionComponent<CourseCardProps> = (props) => {
  const { trailer, playlist, instructor } = props;

  let videoContent: React.ReactNode;
  if (trailer?.hlsPlaylistUrl) {
    const videoJsOptions = {
      controls: true,
      autoplay: true,
      fluid: true,
      muted: false,
      responsive: true,
      preload: 'auto',
      playbackRates: [0.5, 1.0, 1.5, 2.0],
      controlBar: {
        volumePanel: {
          inline: false,
        },
        skipButtons: {
          forward: 30,
          backward: 10,
        },
      },
      html5: {
        hls: {
          overrideNative: true,
        },
      },
      sources: [
        {
          src: trailer.hlsPlaylistUrl,
          type: 'application/x-mpegURL',
        },
      ],
    };

    videoContent = <CustomVideoPlayer options={videoJsOptions} logger />;
  } else {
    videoContent = <VideoUnavailable />;
  }

  return (
    <>
      <PlayerArea>
        <PlayerContainer>{videoContent}</PlayerContainer>
      </PlayerArea>
      <InfoArea>
        <Playlist {...playlist} />
        <HorizontalRule />
        <Instructor {...instructor} />
      </InfoArea>
    </>
  );
};

export default CourseCard;
